// extracted by mini-css-extract-plugin
export default {"container":"contract_container__Zxdbd index_container__UOiPn","btnHolder":"contract_btnHolder__7QVu7 index_btnHolder__qk4lM"};